import type { HeadToHeadOut } from '../types'
import { getTeamColorWithContrast } from '../utils/teamColors'

interface HeadToHeadCardProps {
  h2h: HeadToHeadOut
}

export function HeadToHeadCard({ h2h }: HeadToHeadCardProps) {
  const totalWins = h2h.team1_wins + h2h.team2_wins + h2h.draws

  // Calculate bar widths for visual representation
  const team1Pct = totalWins > 0 ? (h2h.team1_wins / totalWins) * 100 : 0
  const drawsPct = totalWins > 0 ? (h2h.draws / totalWins) * 100 : 0
  const team2Pct = totalWins > 0 ? (h2h.team2_wins / totalWins) * 100 : 0

  // Get team colors
  const team1Color = getTeamColorWithContrast(h2h.team1.name)
  const team2Color = getTeamColorWithContrast(h2h.team2.name)

  return (
    <div className="card" style={{ marginTop: 10, background: 'rgba(255,255,255,.03)' }}>
      <div className="card-inner">
        {/* Header */}
        <div className="small" style={{ textAlign: 'center', marginBottom: 8 }}>
          Head to Head ({h2h.total_matches} matches)
        </div>

        {/* Team header row - matches H2HTab exactly */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1 }}>
            <span className="badge">
              {h2h.team1.crest_url ? <img src={h2h.team1.crest_url} alt="" /> : 'H'}
            </span>
            <div>
              <strong>{h2h.team1.name}</strong>
              <div className="small">{h2h.team1_avg_goals.toFixed(1)} avg goals</div>
            </div>
          </div>
          <div style={{ color: 'var(--muted)', fontWeight: 600 }}>vs</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1, justifyContent: 'flex-end' }}>
            <div style={{ textAlign: 'right' }}>
              <strong>{h2h.team2.name}</strong>
              <div className="small">{h2h.team2_avg_goals.toFixed(1)} avg goals</div>
            </div>
            <span className="badge">
              {h2h.team2.crest_url ? <img src={h2h.team2.crest_url} alt="" /> : 'A'}
            </span>
          </div>
        </div>

        {/* H2H Record row */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <span style={{ fontWeight: 600 }}>{h2h.team1_wins}W</span>
          <span style={{ fontWeight: 600, color: 'var(--muted)' }}>{h2h.draws}D</span>
          <span style={{ fontWeight: 600 }}>{h2h.team2_wins}W</span>
        </div>

        {/* Win bar */}
        <div style={{ display: 'flex', height: 8, borderRadius: 4, overflow: 'hidden' }}>
          <div style={{ width: `${team1Pct}%`, background: team1Color.color, transition: 'width 0.3s' }} />
          <div style={{ width: `${drawsPct}%`, background: 'var(--muted)', transition: 'width 0.3s' }} />
          <div style={{ width: `${team2Pct}%`, background: team2Color.color, transition: 'width 0.3s' }} />
        </div>
      </div>
    </div>
  )
}
